<template>
  <div
    :class="{
      'container-fluid p-0 mt-5': slave && !classes,
      [classes]: true,
      container:
        !slave && !classes && !containerClass.match(/\bcontainer-fluid\b/),
      [containerClass]: true,
    }"
  >
    <template v-if="!isLoading">
      <div v-if="!slave">
        <toolbar
          :label="config.title"
          v-on:change="rerenderComponent"
          :showBreadcrumb="!hideBreadcrumbs || slave"
          :showFilter="!hidePU"
          :view="activeView"
        />
      </div>
      <!-- Form Create  -->
      <div
        id="create"
        ref="create"
        class="animated"
        v-if="activeView === 'create'"
        :key="componentKey + '-create'"
      >
        <slot name="create-form">
          <tas-base-form
            :createConfig="config.createConfig || {}"
            :slave="slave"
            @back="
              config.redirectAfterForm
                ? onSuccessForm('create', null)
                : getEvent('list')
            "
            @success="onSuccessForm('create', $event)"
            :key="config.title + '-form-create'"
            :form="'create'"
            :API="{ setter: configAPI.create, getter: configAPI.read }"
            :title="config.title"
            :fields="fields.create"
            :titleKey="config.title_key || $route.name"
          >
            <template v-slot:form-header="rowData">
              <slot name="form-header" v-bind:rowData="rowData.rowData"></slot>
            </template>
          </tas-base-form>
        </slot>
      </div>
      <!-- Form Update  -->
      <div
        id="update"
        ref="update"
        class="animated"
        v-if="activeView === 'update'"
      >
        <slot
          name="update-form"
          v-bind:data="{ id: activeID, data: activeData }"
        >
          <tas-base-form
            :slave="slave"
            :custom-getter="customGetter"
            @back="
              config.redirectAfterForm
                ? onSuccessForm('update', null)
                : getEvent('list')
            "
            @success="onSuccessForm('update', $event)"
            :key="config.title + '-form-update'"
            :id="activeID"
            :form="'update'"
            :API="{ setter: configAPI.update, getter: configAPI.read }"
            :title="config.title"
            :titleKey="config.title_key || $route.name"
            :fields="fields.update"
            :updateConfig="config.updateConfig || {}"
          >
            <template v-slot:form-header="rowData">
              <slot name="form-header" v-bind:rowData="rowData.rowData"></slot>
            </template>
          </tas-base-form>
        </slot>
      </div>
      <!-- Detail  -->
      <div
        id="detail"
        ref="detail"
        class="animated"
        v-if="activeView === 'detail' && !hideDetail"
      >
        <div
          class="d-flex flex-row align-items-center justify-content-between"
        ></div>
        <slot name="detail-header"></slot>
        <tas-base-detail
          :isBodySlot="!!$scopedSlots['detail-body']"
          :isCustomAPI="config.custom_api ? !!config.custom_api.read : false"
          @zoom="getEvent('zoom', $event)"
          @back="getEvent('list')"
          :key="config.title + '-detail'"
          :id="activeID"
          :slave="config.slave"
          :permission="permission"
          :title="config.title"
          :titleKey="config.title_key || $route.name"
          :API="configAPI.read"
          :fields="fields.detail"
        >
          <template v-slot:detail-body>
            <slot name="detail-body" v-bind:id="activeID"></slot>
          </template>
          <template v-slot:detail-card-body="rowData">
            <slot
              name="detail-card-body"
              v-bind:rowData="rowData.rowData"
            ></slot>
          </template>
          <template v-slot:detail-card-footer="rowData">
            <slot
              name="detail-card-footer"
              v-bind:rowData="rowData.rowData"
            ></slot>
          </template>

          <template v-slot:detail-card-header="rowData">
            <slot
              name="detail-card-header"
              v-bind:rowData="rowData.rowData"
            ></slot>
          </template>
          <template v-slot:detail-footer="rowData">
            <slot name="detail-footer" v-bind:rowData="rowData.rowData"></slot>
          </template>

          <template v-for="(f, i) in fields.detail" v-slot:[f.id]="rowData">
            <div :key="i">
              <slot
                :name="'detail-' + f.id"
                v-bind:rowData="rowData.rowData"
              ></slot>
            </div>
          </template>
        </tas-base-detail>
        <slot name="detail-after-main" :rowData="activeData"></slot>
      </div>
      <!-- List  -->
      <div
        id="list"
        ref="list"
        class="animated"
        v-if="activeView === 'list'"
        :key="componentKey"
      >
        <slot name="list-header"></slot>
        <slot name="list-body">
          <tas-base-table
            :statistic="config.statistic"
            :titleIcon="config.title_icon"
            :hideFilter="hideFilter"
            v-if="!listCard"
            :activeView="activeView"
            @zoom="getEvent('zoom', $event)"
            @add_new="getEvent('create')"
            @filter="getEvent('filter')"
            @export="getEvent('export')"
            @import="getEvent('import')"
            @detail="getEvent('detail', $event)"
            @update="getEvent('update', $event)"
            @delete="getEvent('delete', $event)"
            @successful_deletion="$emit('successful_deletion', $event)"
            @custom_event="$emit('custom_event')"
            :refreshToken="internalRefreshToken"
            :key="config.title + '-list'"
            :slave="slave"
            :permission="permission"
            :title="config.title"
            :titleKey="config.title_key || $route.name"
            :API="configAPI.list"
            :isCustomAPI="config.custom_api ? !!config.custom_api.list : false"
            :endpoint="configAPI"
            :fields="fields.list"
            :exportExcel="config.export"
            :import="config.import"
            :filters="filters"
            :toolbar="!hideToolbar"
            :search="!hideToolbar"
            :detailPreview="config.detailPreview"
            :toolbarType="toolbarType"
            :customEvent="customEvent"
            :hideCreate="hideCreate"
            :hideDetail="hideDetail"
            :hideUpdate="hideUpdate"
            :hideDelete="hideDelete"
            :custom_delete="config.custom_delete"
            :hideAction="hideAction"
            :hideTitle="hideTitle"
            :hideRefresh="hideRefresh"
            :filterData="fields.filter"
            :listConfig="config.listConfig || {}"
            :exportPath="config.exportPath"
            :toolbarClass="toolbarClass || ''"
            :filter_param="
              typeof config.filter_param === 'object' ? config.filter_param : {}
            "
            :indexNumber="indexNumber"
            :multiExpand="tableMultiExpand"
            :hideExpandButton="tableHideExpandButton"
          >
            <!-- list filter  -->
            <!-- <template v-if="!advanceFilter" v-slot:inline-filter> -->
            <!-- <tas-base-form class="animated" btnSaveLabel="Terapkan Filter" v-show="filterView" @back="getEvent('list')" @success="onSuccessForm('filter', $event)" :key="config.title + '-inline-form-filter'" simple :form="'filter'" :API="{ setter: configAPI.create, getter: configAPI.read }" :title="config.title" :fields="fields.filter" /> -->
            <!-- </template> -->
            <template v-slot:inline-filter>
              <slot name="inline-filter"></slot>
            </template>
            <template v-if="$scopedSlots['expand-button']" #expand-button="slotProps">
              <slot name="expand-button" v-bind="slotProps"></slot>
            </template>
            <template v-slot:action-ext-button="{ rowData }">
              <slot name="action-ext-button" v-bind:rowData="rowData"></slot>
            </template>
            <template v-slot:header-search>
              <slot name="header-search"></slot>
            </template>
            <template v-slot:header-title>
              <slot name="header-title"></slot>
            </template>
            <template v-slot:table-action-detail-icon>
              <slot name="table-action-detail-icon"></slot>
            </template>
            <template v-slot:toolbar-title-right>
              <slot name="toolbar-title-right"></slot>
            </template>
            <template v-slot:custom-event-button>
              <slot name="custom-event-button"></slot>
            </template>
            <template v-slot:create-button>
              <slot name="create-button"></slot>
            </template>
            <!-- list action  -->
            <template v-slot:table-action>
              <slot name="list-action"></slot>
            </template>
            <!-- empty list -->
            <template v-slot:empty-data>
              <slot name="empty-data"></slot>
            </template>
            <!-- table header -->

            <template v-slot:header-table="rowData">
              <slot
                name="header-table"
                v-bind:rowData="rowData.rowData"
                v-bind:summary="rowData.summary"
                v-bind:loading="rowData.loading"
              ></slot>
            </template>
            <!-- table data header -->
            <template v-slot:list-header-table>
              <slot name="list-header-table"></slot>
            </template>
            <template #list-middle>
              <slot name="list-middle"></slot>
            </template>
            <template v-slot:list-card-body="rowData">
              <slot
                name="list-card-body"
                v-bind:rowData="rowData.rowData"
                v-bind:loading="rowData.loading"
              ></slot>
            </template>

            <template v-slot:table-action-detail-button="{ rowData }">
              <slot name="table-action-detail-button" v-bind:rowData="rowData">
              </slot>
            </template>

            <template v-slot:table-action-update-button="{ rowData }">
              <slot name="table-action-update-button" v-bind:rowData="rowData">
              </slot>
            </template>

            <template v-slot:header-row="rowData">
              <slot
                name="header-row"
                v-bind:rowData="rowData.rowData"
                v-bind:indicator="rowData.indicator"
                v-bind:loading="rowData.loading"
              ></slot>
            </template>
            <!-- table data -->
            <template v-for="(f, i) in fields.list" v-slot:[f.id]="rowData">
              <div :key="i">
                <slot
                  :name="'list-' + f.id"
                  v-bind:rowData="rowData.rowData"
                  v-bind:indicator="rowData.indicator"
                  v-bind:indexIndicator="rowData.indexIndicator"
                ></slot>
              </div>
            </template>
            <!-- table Detail Preview -->
            <template v-slot:detail-preview="rowData">
              <slot
                name="list-detail-preview"
                v-bind:rowData="rowData.rowData"
              ></slot>
            </template>
            <!-- table data action -->
            <template v-slot:table-data-action="rowData">
              <slot
                name="table-data-action"
                v-bind:rowData="rowData.rowData"
              ></slot>
            </template>
            <template v-slot:list-bottom-action="rowData">
              <slot
                name="list-bottom-action"
                v-bind:rowData="rowData.rowData"
              ></slot>
            </template>
            <!-- table footer -->
            <template v-slot:list-footer-table="rowData">
              <slot
                name="list-footer-table"
                v-bind:rowData="rowData.rowData"
                v-bind:summary="rowData.summary"
              ></slot>
            </template>

            <!-- <template v-slot:footer-table="rowData">
              <slot name="footer-table" v-bind:rowData="rowData.rowData" v-bind:summary="rowData.summary"></slot>
            </template> -->
          </tas-base-table>
          
          <tas-base-card
            v-else
            @zoom="getEvent('zoom', $event)"
            @add_new="getEvent('create')"
            @filter="getEvent('filter')"
            @export="getEvent('export')"
            @import="getEvent('import')"
            @detail="getEvent('detail', $event)"
            @update="getEvent('update', $event)"
            @delete="getEvent('delete', $event)"
            :key="config.title + '-config-list'"
            :slave="slave"
            :permission="permission"
            :title="config.title"
            :API="configAPI.list"
            :endpoint="configAPI"
            :fields="fields.list"
            :export="config.export"
            :import="config.import"
            :filters="filters"
          >
            <!-- <template v-if="!advanceFilter || true" v-slot:inline-filter> -->
            <!-- <h1>test</h1> -->
            <!-- <base-filter class="animated" v-show="filterView" @back="getEvent('list')" @success="onSuccessForm('filter', $event)" :key="config.title + '-inline-form-filter'" simple :form="'filter'" :API="{ setter: configAPI.create, getter: configAPI.read }" :title="config.title" :fields="fields.filter" /> -->
            <!-- </template> -->
            <template v-slot:table-action>
              <slot name="list-action"></slot>
            </template>
            <template v-slot:header-card>
              <slot name="header-card"></slot>
            </template>
            <template v-slot:card-view="rowData">
              <slot name="card-view" v-bind:rowData="rowData.rowData"></slot>
            </template>
          </tas-base-card>
        </slot>
        <slot name="list-footer"></slot>
      </div>
      <div id="list" ref="list" class="animated" v-if="!activeView">
        <not-found></not-found>
      </div>
    </template>
    <template v-else>
      <div class="h-90vh text-center position-relative animated">
        <img
          src="/static/img/loader.svg"
          class="img-fluid"
          style="transform: translate(-50%, -50%); position: absolute; top: 50%"
        />
      </div>
    </template>
    <b-modal id="zoom-modal" hide-footer hide-header centered size="lg">
      <img
        v-img-fb="zoomImg"
        alt="img-zoom"
        class="img-fluid rounded mx-auto d-block"
      />
    </b-modal>
    <b-sidebar
      v-if="!isLoading && advanceFilter"
      @hidden="filterView = false"
      :visible="filterView"
      id="filter-component"
      backdrop
      :backdrop-variant="'light'"
      shadow
      right
      no-header
      body-class="bg-white"
    >
      <tas-base-form
        btnSaveLabel="Terapkan Filter"
        @back="getEvent('list')"
        @success="onSuccessForm('filter', $event)"
        :key="config.title + '-form-filter'"
        :form="'filter'"
        :API="{ setter: configAPI.create, getter: configAPI.read }"
        :title="config.title"
        :fields="fields.filter"
      />
    </b-sidebar>
  </div>
</template>
<script>
import Toolbar from "./component/toolbar.vue";
const merge = require("deepmerge");
export default {
  name: "main-module",
  components: {
    BreadcrumbComponent: require("./component/breadcrumb-component.vue"),
    Toolbar,
  },
  props: {
    indexNumber: { type: Boolean, default: () => true },
    config: { type: Object, required: true },
    listCard: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    advanceFilter: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    hideFilter: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    hideRefresh: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    refreshToken: {
      type: Number,
      default: 0
    },
    customEvent: {
      type: [Object, Boolean],
      required: false,
      default() {
        return false
      }
    },
    hideCreate: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    hideDetail: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    hideDelete: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    hideUpdate: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    hideToolbar: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    hideAction: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    classes: {
      type: String,
      required: false,
      default() {
        return null;
      },
    },
    toolbarType: {
      type: Number,
      required: false,
      default() {
        return 1;
      },
    },
    hideTitle: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    hideRefresh: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    hideBreadcrumbs: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    hidePU: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },

    containerClass: {
      type: String,
      required: false,
      default: () => "",
    },

    toolbarClass: {
      type: String,
      required: false,
      default: () => "",
    },
    tableMultiExpand: {
      type: Boolean,
      default: false
    },
    tableHideExpandButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    slave() {
      let parentTitle = this.$parent.$parent.title;
      if (!parentTitle) parentTitle = this.$parent.$parent.$parent.title;
      if (this.$store.state.activeSlave && parentTitle) {
        if (this.$store.state.activeSlave.master === parentTitle) {
          return true;
        } else return false;
      } else return false;
    },
    temporary_date() {
      return this.$store.state.temporary_date;
    },
  },
  watch: {
    refreshToken: function () {
      this.forwardRefresh()
    },
    config: {
      deep: true,
      immediate: true,
      handler(to, from) {
        if (this.slave && this.$store.state.activeSlave.rules) {
          let rule = JSON.parse(
            JSON.stringify(this.$store.state.activeSlave.rules)
          );
          if (rule.fields) delete rule.fields;
          const newSlaveConfig = { ...to, ...rule };
          this.moduleChange(newSlaveConfig);
        } else this.moduleChange(to);
      },
    },
    activeView: {
      deep: false,
      immediate: false,
      handler(to, from) {
        if (JSON.stringify(this.temporary_date) === "[null]") {
          this.$store.commit("set", ["temporary_date", null, true]);
        }
        if (["create", "update"].includes(from)) {
          // this.resetTmpUp();
        }
        if (!this.slave) {
          if (
            to &&
            this.$route.query.view !== to &&
            ["create", "list", "detail", "update"].includes(
              this.$route.query.view
            )
          ) {
            this.$router
              .push({
                name: this.$route.name,
                query: { view: to, id: this.activeID },
                params: { id: this.activeID },
              })
              .catch(() => {});
          } else {
            if (this.$route.name) {
              // this.$router.push({ name: this.$route.name, query: { 'view': 'list' } }).catch(() => { })
            }
          }
        }
      },
    },
    $route: {
      deep: true,
      immediate: true,
      handler(to) {
        if (!this.slave) {
          this.activeView = to.query.view ? to.query.view : "list";
          this.activeID = to.query.id
            ? isNaN(to.query.id)
              ? to.query.id
              : Number(to.query.id)
            : "";
        } else this.activeView = "list";
      },
    },
  },
  data() {
    return {
      internalRefreshToken: 0,
      componentKey: 1,
      isLoading: true,
      productionUnit: {
        id: null,
        name: "",
      },
      orderedFields: [],
      activeID: null,
      activeData: null,
      activeView: null,
      permission: {},
      filters: null,
      filterView: false,
      viewSlave: null,
      fields: {
        list: [],
        detail: [],
        create: [],
        update: [],
        filter: [],
      },
      configAPI: {},
      customGetter: false,
      zoomImg: null,
    };
  },

  mounted() {
    this.productionUnit = this.$store.state.production_unit;
  },

  methods: {
    async resetTmpUp() {
      this.$store.commit("set", [
        "temporary_up_id",
        this.$store.state.production_unit.id,
        true,
      ]);
      await this.$store.dispatch("setModule");
    },
    rerenderComponent() {
      this.componentKey += 1;
    },
    
    forwardRefresh() {
      this.internalRefreshToken++
    },
    getNewProps(data, rule) {
      let newProps = {};
      Object.assign(newProps, data);
      rule.forEach((f) => {
        let path = f.rule.split(".");
        this.setToValue(newProps, f.value, path);
      });
      let result = Object.keys(newProps).map((key) => newProps[key]);
      return result;
    },
    setToValue(obj, value, path) {
      let i;
      for (i = 0; i < path.length - 1; i++) {
        obj = obj[path[i]];
      }
      obj[path[i]] = value;
    },
    writePermission(hide, permission) {
      if (!hide) {
        return permission;
      } else return null;
    },
    moduleChange(config) {
      this.isLoading = true;
      this.filters = config.filter_api ? config.filter_api : {};
      if (config.permission) {
        this.permission = {
          create: this.writePermission(
            this.hideCreate,
            config.permission.create
          ),
          read: this.writePermission(this.hideDetail, config.permission.read),
          update: this.writePermission(
            this.hideUpdate,
            config.permission.update
          ),
          delete: this.writePermission(
            this.hideDelete,
            config.permission.delete
          ),
        };
      } else {
        this.permission = {
          create: null,
          read: null,
          update: null,
          delete: null,
        };
      }
      if (config.custom_api) {
        this.configAPI = {
          list: config.custom_api.list ? config.custom_api.list : config.getter,
          create: config.custom_api.create
            ? config.custom_api.create
            : config.setter,
          read: config.custom_api.read ? config.custom_api.read : config.getter,
          update: config.custom_api.update
            ? config.custom_api.update
            : config.setter,
          delete: config.custom_api.delete
            ? config.custom_api.delete
            : config.setter,
        };
        if (config.custom_api.read) this.customGetter = true;
      } else {
        this.configAPI = {
          list:
            this.slave &&
            this.$store.state.activeSlave.rules &&
            this.$store.state.activeSlave.rules.getter
              ? this.$store.state.activeSlave.rules.getter
              : config.getter,
          create:
            this.slave &&
            this.$store.state.activeSlave.rules &&
            this.$store.state.activeSlave.rules.getter
              ? this.$store.state.activeSlave.rules.setter
              : config.setter,
          read:
            this.slave &&
            this.$store.state.activeSlave.rules &&
            this.$store.state.activeSlave.rules.getter
              ? this.$store.state.activeSlave.rules.getter
              : config.getter,
          update:
            this.slave &&
            this.$store.state.activeSlave.rules &&
            this.$store.state.activeSlave.rules.getter
              ? this.$store.state.activeSlave.rules.setter
              : config.setter,
          delete:
            this.slave &&
            this.$store.state.activeSlave.rules &&
            this.$store.state.activeSlave.rules.getter
              ? this.$store.state.activeSlave.rules.setter
              : config.setter,
        };
      }
      if (config.model_api) {
        this.$_api.get("/gen-model/" + config.model_api).then(
          (res) => {
            this.generateFieldAPI(res).then((result) => {
              this.buildField(config.fields, result, config.pk_field).then(
                (result) => {
                  this.fields = result;
                  this.isLoading = false;
                }
              );
            });
          },
          (err) => {
            console.log(err);
            this.isLoading = false;
          }
        );
      } else {
        this.buildField(config.fields, [], config.pk_field).then((result) => {
          this.fields = result;
          this.isLoading = false;
        });
      }
    },
    async generateFieldAPI(res) {
      let field = [];
      res.fieldList.forEach((el) => {
        let _field = {
          id: el,
          data: el,
          label: el
            .split("_")
            .map(
              (kebab) =>
                kebab.toLowerCase().charAt(0).toUpperCase() + kebab.slice(1)
            )
            .join(" "),
          placeholder: null,
          methods: {
            list: res.fieldList.find((x) => x === el)
              ? this.defineTypeAPI(res.fieldType[el], res, el, "list")
              : false,
            detail: res.fieldView.find((x) => x === el)
              ? this.defineTypeAPI(res.fieldType[el], res, el, "detail")
              : false,
            create: res.fieldAdd.find((x) => x === el)
              ? this.defineTypeAPI(res.fieldType[el], res, el, "create")
              : false,
            update: res.fieldEdit.find((x) => x === el)
              ? this.defineTypeAPI(res.fieldType[el], res, el, "update")
              : false,
            // filter: Object.keys(res.fieldFilterable).find(x => x === el) ? this.defineTypeAPI(res.fieldType[el], res, el, 'filter') : false
            filter: false, // set default to false
          },
        };
        field.push(_field);
      });
      return field;
    },
    defineRelationAPI(data, pointer) {
      if (data.fieldRelation[pointer]) {
        return data.fieldRelation[pointer].displayName;
      } else return pointer;
    },
    defineTypeAPI(item, data, pointer, from) {
      let _tmp = {};
      let toReturn = {};
      switch (item) {
        case "integer":
          _tmp.listType = "text";
          _tmp.formType = "number";
          _tmp.transform = pointer;
          _tmp.view_data = this.defineRelationAPI(data, pointer);
          break;
        case "timestamp_with_time_zone":
          _tmp.listType = "text";
          _tmp.formType = "datetime";
          _tmp.transform = "longDateTime";
          _tmp.view_data = this.defineRelationAPI(data, pointer);
          break;
        case "bigint":
          _tmp.listType = "text";
          _tmp.formType = "number";
          _tmp.transform = "number";
          _tmp.view_data = this.defineRelationAPI(data, pointer);
          break;
        case "double_precision":
          _tmp.listType = "text";
          _tmp.formType = "text";
          _tmp.transform = "text";
          _tmp.view_data = this.defineRelationAPI(data, pointer);
          break;
        case "character_varying":
          _tmp.listType = "text";
          _tmp.formType = "text";
          _tmp.transform = null;
          _tmp.view_data = this.defineRelationAPI(data, pointer);
          break;
        case "enum":
          _tmp.listType = "text";
          _tmp.formType = "number";
          _tmp.transform = null;
          _tmp.view_data = this.defineRelationAPI(data, pointer);
          break;
        case "text":
          _tmp.listType = "text";
          _tmp.formType = "text";
          _tmp.transform = null;
          _tmp.view_data = this.defineRelationAPI(data, pointer);
          break;
        default:
          _tmp = "unset";
      }
      if (_tmp !== "unset" && data.fieldValidation[pointer]) {
        let ignore = ["nullable", "string", "exists_file", "date", "integer"];
        _tmp.validation = data.fieldValidation[pointer]
          .split("|")
          .filter((x) => !ignore.includes(x));
      } else _tmp = true;
      switch (from) {
        case "list":
          toReturn.type = _tmp.listType;
          toReturn.transform = _tmp.transform;
          toReturn.view_data = _tmp.view_data;
          break;
        case "detail":
          toReturn.type = _tmp.listType;
          toReturn.transform = _tmp.transform;
          toReturn.view_data = _tmp.view_data;
          break;
        case "create":
          toReturn.type = _tmp.formType;
          toReturn.transform = _tmp.transform;
          toReturn.validation = _tmp.validation;
          break;
        case "update":
          toReturn.type = _tmp.formType;
          toReturn.transform = _tmp.transform;
          toReturn.validation = _tmp.validation;
          break;
        case "filter":
          toReturn.type = _tmp.formType;
          toReturn.transform = _tmp.transform;
          break;
      }
      return toReturn;
    },
    buidView(config) {
      if (config.mode) {
        let view = {
          list: config.mode.list || "default",
          detail: config.mode.detail || "default",
          create: config.mode.create || "default",
          update: config.mode.update || "default",
          filter: config.mode.filter || "default",
        };
        Object.keys(view).forEach((el) => {
          if (view[el] !== "default" && view[el] !== "modal") {
            view[el] = {
              type: el + "-custom",
              file: view[el],
            };
          } else if (view[el] === "default") {
            view[el] = {
              type: el + "-default",
              file: null,
            };
          } else {
            view[el] = {
              type: el + "-modal",
              file: null,
            };
          }
        });
        return view;
      }
    },
    mergeArr(a, b, prop) {
      const map = new Map();
      a.forEach((item) => map.set(item[prop], item));
      b.forEach((item) =>
        map.set(item[prop], merge(map.get(item[prop]), item))
      );
      return Array.from(map.values());
    },
    async buildField(local, server, pk = null) {
      let field = { list: [], detail: [], create: [], update: [], filter: [] };
      let _data = server.length ? this.mergeArr(server, local, "id") : local;
      let data =
        this.slave &&
        this.$store.state.activeSlave.rules &&
        this.$store.state.activeSlave.rules.fields
          ? this.getNewProps(_data, this.$store.state.activeSlave.rules.fields)
          : _data;
      let sortedData = pk ? this.swapPrimaryField(data, pk) : data;
      await sortedData.forEach(async (item) => {
        if (item.label === "Production Unit") {
          console.log(item);
        }
        let def = {
          id: item.id,
          data: item.data ? item.data : item.id,
          label: item.label_key
            ? this.$t(`table_head.${item.label_key}`)
            : item.label,
          placeholder: item.placeholder,
          hint: item.hint || null,
        };
        let list = {};
        let detail = {};
        let create = {};
        let update = {};
        let filter = {};
        if (item.methods) {
          if (item.methods.list) {
            if (typeof item.methods.list === "object") {
              // let viewData = typeof item.methods.list.view_data === 'array'
              list = {
                show:
                  item.methods.list.show === undefined
                    ? true
                    : item.methods.list.show,
                order:
                  item.methods.list.order === undefined
                    ? true
                    : item.methods.list.order,
                view_data: item.methods.list.view_data || def.data,
                header_class: item.methods.list.header_class,
                link: item.methods.list.link,
                permission:
                  item.methods.list.permission || "template-allow-all",
                type: item.methods.list.type || "text",
                class: item.methods.list.class || "",
                transform: item.methods.list.transform,
                event: item.methods.list.event,
                param_id: item.methods.list.param_id,
                param: item.methods.list.param || {},
                row_class: item.methods.list.row_class || "",
                tooltip: item.methods.list.tooltip || false,
                parse_static_option: item.methods.list.parse_static_option,
              };
            } else {
              list = {
                show: true,
                order: true,
                permission: "template-allow-all",
                view_data: def.data,
                type: "text",
                class: "",
                row_class: "",
              };
            }
            field.list.push({ ...def, ...list });
          }
          if (item.methods.detail) {
            if (typeof item.methods.detail === "object") {
              detail = {
                show:
                  item.methods.detail.show === undefined
                    ? true
                    : item.methods.detail.show,
                order:
                  item.methods.detail.order === undefined
                    ? true
                    : item.methods.detail.order,
                permission:
                  item.methods.detail.permission || "template-allow-all",
                view_data: item.methods.detail.view_data || def.data,
                type: item.methods.detail.type || "text",
                class: item.methods.detail.class || "",
                transform: item.methods.detail.transform,
                event: item.methods.detail.event,
                parse_static_option: item.methods.detail.parse_static_option,
                view_condition: item.methods.detail.view_condition,
              };
            } else {
              detail = {
                show: true,
                order: true,
                permission: "template-allow-all",
                view_data: def.data,
                type: "text",
                class: "",
              };
            }
            field.detail.push({ ...def, ...detail });
          }
          if (item.methods.create) {
            if (typeof item.methods.create === "object") {
              create = {
                show:
                  item.methods.create.show === undefined
                    ? true
                    : item.methods.create.show,
                view_data: item.methods.create.view_data || def.data,
                permission:
                  item.methods.create.permission || "template-allow-all",
                setter: item.methods.create.setter,
                getter: item.methods.create.getter,
                type: item.methods.create.type || "text",
                class: item.methods.create.class || "",
                attr: item.methods.create.attr || null,
                value: item.methods.create.value,
                transform_after: item.methods.create.transform_after,
                transform_before: item.methods.create.transform_before,
                validation: Array.isArray(item.methods.create.validation)
                  ? item.methods.create.validation
                  : [],
                event: item.methods.create.event,
                option: item.methods.create.option,
                options: item.methods.create.options,
                labelGroup: item.methods.create.labelGroup || null,
                separator: item.methods.create.separator || false,
                autoFill: item.methods.create.autoFill || false,
                decimal: item.methods.update.decimal || false,
                filter_param: item.methods.update.filter_param || null,
              };
            } else {
              create = {
                show: true,
                view_data: def.data,
                permission: "template-allow-all",
                type: item.methods.create.type || "text",
                class: "",
                attr: null,
                validation: [],
                value: null,
              };
            }
            field.create.push({ ...def, ...create });
          }
          if (item.methods.update) {
            if (typeof item.methods.update === "object") {
              update = {
                show:
                  item.methods.update.show === undefined
                    ? true
                    : item.methods.update.show,
                view_data: item.methods.update.view_data || def.data,
                permission:
                  item.methods.update.permission || "template-allow-all",
                setter: item.methods.update.setter,
                getter: item.methods.update.getter,
                type: item.methods.update.type || "text",
                class: item.methods.update.class || "",
                attr: item.methods.update.attr || null,
                value: item.methods.update.value,
                transform_after: item.methods.update.transform_after,
                transform_before: item.methods.update.transform_before,
                validation: Array.isArray(item.methods.update.validation)
                  ? item.methods.update.validation
                  : [],
                event: item.methods.update.event,
                option: item.methods.update.option,
                options: item.methods.update.options,
                labelGroup: item.methods.update.labelGroup || null,
                separator: item.methods.update.separator || false,
                disabled: item.methods.update.disabled || false,
                decimal: item.methods.update.decimal || false,
                defaultCaption: item.methods.update.defaultCaption || null,
                dataLabel: item.methods.update.dataLabel || null,
              };
            } else {
              update = {
                show: true,
                view_data: def.data,
                permission: "template-allow-all",
                type: item.methods.update.type || "text",
                class: "",
                attr: null,
                validation: [],
                value: null,
              };
            }
            field.update.push({ ...def, ...update });
          }
          if (item.methods.filter) {
            if (typeof item.methods.filter === "object") {
              filter = {
                show:
                  item.methods.filter.show === undefined
                    ? true
                    : item.methods.filter.show,
                view_data: item.methods.filter.view_data || def.data,
                permission:
                  item.methods.filter.permission || "template-allow-all",
                setter: item.methods.filter.setter,
                getter: item.methods.filter.getter,
                type: item.methods.filter.type || "text",
                class: item.methods.filter.class || "",
                attr: item.methods.filter.attr || null,
                value: item.methods.filter.value,
                transform_after: item.methods.filter.transform_after,
                transform_before: item.methods.filter.transform_before,
                validation: Array.isArray(item.methods.filter.validation)
                  ? item.methods.filter.validation
                  : [],
                event: item.methods.filter.event,
                option: item.methods.filter.option,
                options: [],
                main: item.methods.filter.main || false,
                params: item.methods.filter.params || null,
                today_filter: item.methods.filter.today_filter || false,
                data_type: item.methods.filter.data_type || null,
              };

              if (
                item.methods.filter.option &&
                item.methods.filter.option.list_pointer &&
                Array.isArray(item.methods.filter.option.list_pointer.list) &&
                !item.methods.filter.option.list_pointer.list.find(
                  (x) => !x.code
                )
              ) {
                // label "Semua ${label}"
                // filter.option.list_pointer.list.unshift({
                //   label: `${this.$t("global.all")} ${item.label}`,
                //   code: null,
                // });
              }

              if (
                item.methods.filter.option &&
                item.methods.filter.option.list_pointer &&
                Array.isArray(item.methods.filter.option.list_pointer.list)
              ) {
                for (const filterItem of item.methods.filter.option.list_pointer
                  .list) {
                  if (filterItem.label_key) {
                    filterItem.label = this.$t(
                      `global.${filterItem.label_key}`
                    );
                  }
                }
              }
            } else {
              filter = {
                show: true,
                view_data: def.data,
                permission: "template-allow-all",
                type: item.methods.filter.type || "text",
                class: "",
                attr: null,
                validation: [],
                value: null,
              };
            }
            field.filter.push({ ...def, ...filter });
          }
        } else console.log("Konfigurasi Field " + item.id + " Tidak ditemukan");
      });

      let processedFieldUpdate = [];

      if (
        this.config.updateConfig &&
        this.config.updateConfig.order &&
        Array.isArray(this.config.updateConfig.order) &&
        this.config.updateConfig.order.length > 0
      ) {
        for (var i = this.config.updateConfig.order.length - 1; i >= 0; i--) {
          var keyId = this.config.updateConfig.order[i];
          var configData = field.update.find((x) => x.id === keyId);
          if (!configData) continue;
          processedFieldUpdate.unshift(configData);
        }

        field.update = processedFieldUpdate;
      }

      let processedFieldCreate = [];

      if (
        this.config.createConfig &&
        this.config.createConfig.order &&
        Array.isArray(this.config.createConfig.order) &&
        this.config.createConfig.order.length > 0
      ) {
        for (var i = this.config.createConfig.order.length - 1; i >= 0; i--) {
          var keyId = this.config.createConfig.order[i];
          var configData = field.create.find((x) => x.id === keyId);
          if (!configData) continue;
          processedFieldCreate.unshift(configData);
        }

        field.create = processedFieldCreate;
      }
      return field;
    },
    swapPrimaryField(arr, primary) {
      if (!primary) return arr;
      let pk = arr.findIndex((x) => x.id === primary);
      if (pk === -1) return arr;
      else {
        var temp = arr[0];
        arr[0] = arr[pk];
        arr[pk] = temp;
        return arr;
      }
    },
    onSuccessForm(from, e) {
      if (from === "update") {
        if (this.config.redirectAfterForm) {
          let routeQuery = this.config.redirectAfterForm;
          for (const query of Object.keys(routeQuery.query)) {
            if (
              routeQuery.query &&
              routeQuery.query[query] &&
              typeof routeQuery.query[query] == "string" &&
              routeQuery.query[query].charAt(0) === ":"
            ) {
              routeQuery.query[query] = e[query];
            }
          }

          this.$router.replace(routeQuery).catch((err) => {
            return err;
          });
        } else {
          this.$router
            .replace({
              query: {
                view: this.hideDetail ? "list" : "detail",
                id: this.hideDetail ? null : e.id || e.code || null,
              },
            })
            .catch((err) => {
              console.log("ER", err);
              this.$router.go(-1);
            });

          //force go back if not redirect
          // this.$router.go(-1);
          this.$_alert.success(
            null,
            "Edit data " + this.config.title + " berhasil"
          );
        }
      } else if (from === "create") {
        if (this.config.redirectAfterForm) {
          let routeQuery = this.config.redirectAfterForm;

          for (const query of Object.keys(routeQuery.query)) {
            if (
              routeQuery.query &&
              routeQuery.query[query] &&
              typeof routeQuery.query[query] == "string" &&
              routeQuery.query[query].charAt(0) === ":"
            ) {
              routeQuery.query[query] = e[query];
            }
          }

          console.log("QUERY", routeQuery);
          this.$router.replace(routeQuery).catch((err) => {
            return err;
          });
        } else {
          if (e.id || e.code) {
            const _view = this.hideDetail ? "list" : "detail";
            this.$router
              .replace({
                query: {
                  view: _view,
                  id: this.hideDetail ? null : e.id || e.code || null,
                },
              })
              .catch((err) => {
                this.$router.go(-1);
              });
            //force go back if not redirect
            this.$_alert.success(
              null,
              "Data " + this.config.title + " berhasil ditambahkan"
            );
          } else {
            this.$router.go(-1);
          }
        }
      } else if (from === "filter") {
        this.filters = {
          ...this.$_sys.cleansingObj(e),
          ...this.config.filter_api,
        };
        this.filterView = false;
      }
    },
    getEvent(type, data = null) {
      switch (type) {
        case "detail":
          this.activeView = "detail";
          this.activeID = data.id;
          this.activeData = data;
          break;
        case "list":
          this.activeView = "list";
          this.activeID = null;
          this.activeData = null;
          break;
        case "update":
          this.activeView = "update";
          this.activeID = data.id;
          this.activeData = data.data;

          // this.$router.replace({ query: { id: data.id, view: type}})
          break;
        case "create":
          this.activeView = "create";
          this.activeID = null;
          this.activeData = null;
          break;
        case "filter":
          this.filterView = !this.filterView;
          this.activeID = null;
          this.activeData = null;
          break;
        case "zoom":
          this.zoomImg = data;
          this.$nextTick(function () {
            this.$bvModal.show("zoom-modal");
          });
          break;
        // case "delete":
        //   this.activeView = "delete";
        //   this.activeID = data.id;
        //   this.activeData = null;
        //   break;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/base/main-crud.vue